import { useState, useEffect, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { globalPrompt } from "@/components/message";
import { IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { IPurchaseOfferFields, IDetailList } from "../../purchaseOfferType"
import { purchaseOfferService } from "../../purchaseOfferService"
import { transPgToPagination, formatNum, IsUseDefaultBentity, momentFormat, bigNumber } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { IStockStatisticDetail } from "@/views/stock/statistic/stockStatisticService";
import { useLockFn } from "ahooks";
import { message } from "antd";
import moment from "moment";
export type IVrmOfferDescType = {
    numAll: number,
    totalAllprice: number,
    [key: string]: any
}
export const usePurchaseOfferDetailsModel = createModel(function () {
    const { user, setLoadingInfo, shopAndOrg, beShopDs } = useGlobalModel()
    const { shopId, shopName, shopCode } = shopAndOrg
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const initDesc = {
        numAll: 0,  //数量
        totalAllprice: 0 //总计
    }
    const initForm = {
        shopId, shopName,
        // endTime: moment(new Date()),
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IMaterialSearchFields = {};
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IPurchaseOfferFields>(initForm)
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IPurchaseOfferFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    //供应商列表
    const [supplierList, setSupplierList] = useState<any[]>([]);
    //供应商列表弹窗
    const [addSupplierVisible, setAddSupplierVisible] = useState<boolean>(false);
    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<IPurchaseOfferFields>({})

    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<any[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IMaterialSearchFields>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<any[]>([]);
    const [saveLoading, setSaveLoading] = useState<boolean>(false); //  保存按钮
    const [secSaveLoading, setSecSaveLoading] = useState<boolean>(false); //  保存按钮
    const [addDesc, setAddDesc] = useState<IVrmOfferDescType>(initDesc)
    const [editDesc, setEditDesc] = useState<IVrmOfferDescType>(initDesc)
    const [lookDesc, setLookDesc] = useState<IVrmOfferDescType>(initDesc)
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)
    const typeForm: any = {
        add: { ...detailAddForm, shopId, shopCode, shopName },
        edit: detailEditForm,
        look: detailLookForm
    }
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    useEffect(() => {
        let newDesc: IVrmOfferDescType = initDesc;
        detailDataSource && detailDataSource.forEach(item => {
            newDesc.numAll = +bigNumber.add(Number(item.num ?? 0), newDesc.numAll);;
            newDesc.totalAllprice = +bigNumber.add(bigNumber.times(Number(item.num ?? 0), Number(item.controlPrice ?? 0)), newDesc.totalAllprice);
        });
        newDesc.itemNumAll = detailDataSource && detailDataSource.length
        setEditDesc(newDesc);
    }, [detailDataSource])

    useEffect(() => {
        let newDesc: IVrmOfferDescType = initDesc;
        detailAddList && detailAddList.forEach(item => {
            newDesc.numAll = +bigNumber.add(Number(item.num ?? 0), newDesc.numAll);;
            newDesc.totalAllprice = +bigNumber.add(bigNumber.times(Number(item.num ?? 0), Number(item.controlPrice ?? 0)), newDesc.totalAllprice);
        });
        newDesc.itemNumAll = detailAddList && detailAddList.length
        setAddDesc(newDesc);
    }, [detailAddList])

    useEffect(() => {
        let newDesc: IVrmOfferDescType = initDesc;
        detailLookList && detailLookList.forEach(item => {
            newDesc.numAll = +bigNumber.add(Number(item.num ?? 0), newDesc.numAll);;
            newDesc.totalAllprice = +bigNumber.add(bigNumber.times(Number(item.num ?? 0), Number(item.controlPrice ?? 0)), newDesc.totalAllprice);
        });
        newDesc.itemNumAll = detailLookList && detailLookList.length
        setLookDesc(newDesc);
    }, [detailLookList])
    //新增表单缓存
    const updateAddFormVal = (val: IPurchaseOfferFields) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IPurchaseOfferFields) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await purchaseOfferService.one(id);
        const { details, supplierInfo, ...from } = retData
        if (retData) {
            let fileList: any = []
            let fileList2: any = []
            const { md5, fileName, supplierMd5, supplierFileName } = from
            if (md5) {
                fileList = [
                    {
                        uid: md5,
                        status: 'done',
                        name: fileName,
                        response: {
                            retData: md5,
                        },
                    },
                ]
            }
            if (supplierMd5) {
                fileList2 = [
                    {
                        uid: supplierMd5,
                        status: 'done',
                        name: supplierFileName,
                        response: {
                            retData: supplierMd5,
                        },
                    },
                ]
            }
            let newDetails: any = details?.map((item) => {
                return {
                    ...item,
                    totalPrice: bigNumber.times(Number(item.num ?? 0), Number(item.offerPrice ?? 0))
                }
            })
            from.fileList = fileList
            from.fileList2 = fileList2
            if (pattern === "edit") {
                setDetailDataSource(newDetails as IDetailList[] ?? [])
                setDetailEditForm({
                    ...from,
                    endTime: from.endTime ? moment(from.endTime, 'YYYY-MM-DD HH:mm:ss') : null,
                    createTimes: from.createTime ? momentFormat(from.createTime) : null,
                    updateTimes: from.updateTime ? momentFormat(from.updateTime) : null,
                })
                setTopButsControl(false)
            } else if (pattern === "look") {
                setDetailLookForm({
                    ...from,
                    endTime: from.endTime ? moment(from.endTime, 'YYYY-MM-DD HH:mm:ss') : null,
                    createTimes: from.createTime ? momentFormat(from.createTime) : null,
                    updateTimes: from.updateTime ? momentFormat(from.updateTime) : null,
                });
                setDetailLookList(newDetails as IDetailList[] ?? [])
            }
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    const [addLoading, setAddLoading] = useState<boolean>(false)
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IMaterialSearchFields = searchWorkData) => {
        setAddLoading(true)
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await materialService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            let { latestPurPrice, materialDetal, materialShelfVo } = item
            let materialOne = (materialDetal ?? [])[0]
            materialShelfVo = materialShelfVo ?? {}
            //取最近采购价格，没有的话取档案进货价
            let purchasePrice = !!latestPurPrice ? latestPurPrice : materialOne?.purchasePrice ?? 0;
            return {
                ...item,
                num: 1,
                controlPrice: purchasePrice
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
        setAddLoading(false)
    }

    //表单计算校验 (计算主单信息与配件每一项)
    const formComputeRule = (mode: string): boolean => {
        let goods = mode === 'edit' ? detailDataSource : detailAddList;
        // let zeroNum = goods.filter((item) => !item.model);
        // debugger
        // if (zeroNum.length) {
        //     message.warning(
        //         `请补全【${zeroNum.map((item) => item.materialName).join()}】配件的规格型号`
        //     );
        //     return false;
        // }
        // let allPrice = goods.filter((item) => item.totalPrice == 0);
        // if (allPrice.length) {
        //     message.warning(
        //         `请完善【${allPrice.map((item) => item.materialName).join()}】配件的报价金额`
        //     );
        //     return false;
        // }
        let allData = goods.filter((item) => !item.deliveryTime && item.offerPrice !== 0);
        if (allData.length) {
            message.warning(
                `【${allData.map((item) => item.materialName).join()}请补全交货期`
            );
            return false;
        }
        return true;
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: any[], detailList: IDetailList[], mode: string) => {
        console.log(modelList, detailList)
        const repetition: string[] = [];
        const newDetailData: any[] = [...detailList]
        modelList.forEach(Item => {
            let isSelect = newDetailData.find(item => item.materialCode === (Item.materialCode ?? Item.code));
            if (isSelect === undefined) {
                newDetailData.push({
                    // ...Item,
                    id: "",
                    materialCode: Item.materialCode ?? Item.code,
                    materialName: Item.materialName ?? Item.name,
                    model: Item.model,
                    unitName: Item.unitName,
                    unitCode: Item.unitCode,
                    num: Item.num,
                    controlPrice: 0,
                    producingArea: Item.producingArea,
                    deliveryTime: 0,
                });
            } else {
                repetition.push(`【${Item.materialName ?? Item.name} (${Item.materialCode ?? Item.code})】`);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToPoDetailList = async (mode: string) => {
        //添加列表
        if (mode === "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList, mode)
            setDetailAddList([...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });
            setTopButsControl(true)
        } else if (mode === "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource, mode)
            setDetailDataSource([...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `${repetition.join(",")}，以上重复配件已过滤。`, type: "warning" });
            setTopButsControl(true)
        }
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string, Material?: IDetailList) => {
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        let newRowKeys = mode === 'add' ? detaiAddDataRowKeys : detailDataRowKeys
        const filterDetailList = Material ? newData.filter(el => !!!(Material.materialCode === el.materialCode)) : newData.filter(el => !!!newRowKeys.find(ele => ele === el.materialCode));
        mode === "edit" ? setDetailDataSource([...filterDetailList]) : setDetailAddList([...filterDetailList])
        globalPrompt("message", { text: `删除成功`, type: "success" });
        setDetaiAddDataRowKeys([]);
        setDetaiAddDataRow([]);
        setTopButsControl(true)
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IPurchaseOfferFields) => {
        try {
            let newParams = {
                ...params,
                details: detailAddList,
                createUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchaseOfferService.insert(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IPurchaseOfferFields) => {
        try {
            let newParams = {
                ...params,
                details: detailDataSource,
                updateUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchaseOfferService.update(newParams);
            setSaveLoading(false)
            return retData;
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddForm(initForm)
        setDetailAddList([]);
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }
    const downloadTpl = async () => {
        let result = await purchaseOfferService.downloadTpl();
        convertRes2Blob(result)
    }
    const Submit = useLockFn(async () => {
        let { retData } = await purchaseOfferService.submit(detailEditForm.id as string);
        return retData
    })
    const toReport = useLockFn(async (id) => {
        let { retData } = await purchaseOfferService.toReport(id as string);
        return retData
    })
    const Transfer = useLockFn(async (val) => {
        let { retData } = await purchaseOfferService.transfer({
            id: detailEditForm.id,
            status: val
        });
        return retData
    })
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [supplierHistoryVisible, setSupplierHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [supplierHistoryModel, setSupplierHistoryModel] = useState<{ supplierName: string }>({ supplierName: "" }) //消费记录参数

    //详情导出
    const exportPurchaseOfferDetail = async (code: string) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        try {
            let result = await purchaseOfferService.exportDetail(code);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }

    return {
        addModalVisible, addLoading,
        initPgCfg,
        detailAddForm,
        detailAddList,
        detaiAddDataRow,
        detailLookForm,
        detailLookList,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        detaiAddDataRowKeys,
        addDesc,
        editDesc,
        lookDesc,
        setAddDesc,
        setEditDesc,
        setLookDesc,
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRow,
        setDetailLookForm,
        setDetailLookList,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        transformsToPoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        setDetaiAddDataRowKeys,
        downloadTpl,
        modelScreenMethod,
        Transfer,
        Submit,
        toReport,
        initForm, formComputeRule,
        topButsControl, setTopButsControl,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
        supplierHistoryVisible, setSupplierHistoryVisible,
        supplierHistoryModel, setSupplierHistoryModel,
        saveLoading, setSaveLoading,
        secSaveLoading, setSecSaveLoading,
        supplierList, setSupplierList,
        addSupplierVisible, setAddSupplierVisible,
        exportPurchaseOfferDetail, more, setMore
    }
})